import { useDispatch } from "react-redux";
import { setContextMenuOptions, setContextMenuCoords, setContextMenuOpened } from "../../actions/contextMenuActions";

const ContextualActivator = ({children, contextMenuOptions, onClickLeft = false, disabled = false}) => {
    const dispatch = useDispatch();

    const openContextMenu = (e) => {
        setTimeout(() => {
            dispatch(setContextMenuOpened(true));
            dispatch(setContextMenuCoords({x: e.pageX, y: e.pageY}));
            dispatch(setContextMenuOptions(contextMenuOptions));
        }, 10);
    }

    return (
        <div
            onContextMenu={(e) => {
                e.preventDefault();

                if(disabled) return;

                openContextMenu(e);
            }}

            onClick={(e) => {
                if(!onClickLeft || disabled) return;

                openContextMenu(e);
            }}
        >
            {children}
        </div>
    )
}

export default ContextualActivator;